import { TabPanel } from '@mui/lab';
import styled from 'styled-components';

export const CustomTabPanel = styled(TabPanel)`
  padding: 0;
`;
